<template>
  <el-dialog
    title="选择核销门店"
    :visible="visible"
    width="400px"
    :close-on-click-modal="false"
    :before-close="close"
    @closed="reset"
  >
    <div class="shop-select-wrap" v-loading="beLoading">
      <el-form label-width="100px">
        <el-form-item label="活动名称" v-if="row">
          <span>{{ row.actName }}</span>
        </el-form-item>
        <el-form-item label="会员姓名" v-if="row">
          <span>{{ row.realName || row.memberName }}</span>
        </el-form-item>
        <el-form-item label="会员电话" v-if="row">
          <span>{{ row.memberMobile }}</span>
        </el-form-item>
        <el-form-item label="活动场次" v-if="row">
          <span>{{ row.actRound }}</span>
        </el-form-item>
        <el-form-item label="活动地点" v-if="row">
          <span>{{ row.actSite }}</span>
        </el-form-item>
        <el-form-item label="选择门店">
          <el-select
            v-model="selectedShopName"
            placeholder="请选择门店"
            style="width: 100%"
            filterable
            clearable
          >
            <el-option
              v-for="item in shopList"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">取消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="confirming"
        @click="confirm"
        >确认核销</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "VerifyShopDialog",
  components: {},
  props: {
    storeCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      beLoading: false,
      row: null,
      shopList: [],
      selectedShopName: "",
      confirming: false
    };
  },
  methods: {
    // 打开弹框前先按核销码查询门店，有门店才弹出弹框；
    // 无门店时直接走 fallback 回调（弹框不弹出，避免影响体验）
    openShop(row) {
      this.row = row;
      this.shopList = [];
      this.selectedShopName = "";
      if (!row) {
        return;
      }
      this.beLoading = true;
      this.$store
        .dispatch("guiderFindByVerifyCode", {
          verifyCode: row.authCode,
          storeCode: this.storeCode,
          queryType: "subscribeById", // 走宽松按id查询，与 do_charge_by_id 核销逻辑保持一致
          subscribeApplyId: row.id // 预约记录id
        })
        .then(async res => {
          if (res.code !== "0") {
            this.beLoading = false;
            this.close();
            return;
          }
          const hexiaoInfo = res.result;
          // 处理门店列表
          if (hexiaoInfo.actShopType === "all") {
            // 全部门店，需要查询所有启用的门店列表
            try {
              const shopRes = await this.$store.dispatch(
                "queryStoreAllEnabledStatusShopList"
              );
              if (shopRes.code === "0") {
                this.shopList = shopRes.result.map(item => ({
                  name: item.shopName
                }));
              }
            } catch (e) {
              // 忽略，下面按门店列表是否为空判断
            }
          } else if (hexiaoInfo.actShopName) {
            // 指定门店，解析门店名称
            this.shopList = hexiaoInfo.actShopName
              .split(",")
              .map(name => ({
                name: name.replace(/^(直营店-|加盟店-)/, "")
              }));
          }
          this.beLoading = false;
          // 有门店才打开弹框；无门店走原核销流程（不弹出弹框，避免闪动）
          if (this.shopList.length === 0) {
            this.$emit("fallback", this.row);
            this.close();
            return;
          }
          this.selectedShopName =
            this.shopList[0] && this.shopList[0].name ? this.shopList[0].name : "";
          this.visible = true;
        })
        .catch(() => {
          this.beLoading = false;
          this.close();
        });
    },
    confirm() {
      if (!this.selectedShopName) {
        this.$message({
          message: "请选择核销门店",
          type: "warning"
        });
        return;
      }
      this.confirming = true;
      this.$store
        .dispatch("chargeFromId", {
          id: this.row.id,
          chargeStatus: 1,
          selectedShopName: this.selectedShopName
        })
        .then(res => {
          this.confirming = false;
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.$emit("confirmed");
            this.close();
          }
        });
    },
    close() {
      this.visible = false;
    },
    reset() {
      this.row = null;
      this.shopList = [];
      this.selectedShopName = "";
    }
  }
};
</script>